import { Component, inject } from '@angular/core';
import { Candidate } from '$synapse/models';
import { GroupService } from '$synapse/services';
import { Observable } from 'rxjs';
import { GroupSummary } from '$synapse/dtos';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GroupPickerComponent } from '$synapse/core';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-candidates-add-to-group',
  templateUrl: './candidates-add-to-group.component.html',
  imports: [SHARED_IMPORTS, GroupPickerComponent],
})
export class CandidatesAddToGroupComponent {
  private readonly _candidates = inject(MAT_DIALOG_DATA);
  private readonly _groupService = inject(GroupService);
  readonly _modalDisplay =
    inject<MatDialogRef<CandidatesAddToGroupComponent>>(MatDialogRef);

  groupList: GroupSummary[];
  send = false;
  isEmptyGroupList = true;

  submit(): void {
    this.send = true;
    this.groupList.forEach((groupSummary: GroupSummary) => {
      this.addCandidatesToGroup(groupSummary).subscribe(
        (candidates: Candidate[]) => {
          this._modalDisplay.close(candidates);
        }
      );
    });
  }

  private addCandidatesToGroup(group: GroupSummary): Observable<Candidate[]> {
    return this._groupService.addCandidatesToGroup(
      group,
      this._candidates.map((candidate) => candidate.id)
    );
  }

  addGroup(event: GroupSummary[]) {
    if (event) {
      this.groupList = event;
    }
  }
}
